import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { storageService } from '../../services/storageService';
import { permissionService } from '../../services/permissionService';
import { UserUtils } from '../../helpers/userUtils';
import { RoleType, getRoleString } from '../../models/enums/roleType';

export const HomeHeader: React.FC = () => {
    const user = storageService.getUserData();
    const userFio = user ? UserUtils.getFio(user) : '';
    const roles = permissionService.getRoles();

    const getRoleName = (): string => {
        if (roles.length === 0) {
            return getRoleString(RoleType.Undefined);
        }

        // Приоритет ролей для сортировки: Admin > Medic > Dispatcher > Driver
        const rolePriority: Record<RoleType, number> = {
            [RoleType.Admin]: 1,
            [RoleType.Medic]: 2,
            [RoleType.Dispatcher]: 3,
            [RoleType.Driver]: 4,
            [RoleType.Undefined]: 5,
        };

        // Сортируем роли по приоритету и преобразуем в строки
        const sortedRoles = roles
            .sort((a, b) => (rolePriority[a] || 99) - (rolePriority[b] || 99))
            .map(role => getRoleString(role));

        return sortedRoles.join(', ');
    };

    const roleName = getRoleName();

    return (
        <Box sx={{ mb: 4, py: { xs: 2, sm: 3 }, borderBottom: '1px solid', borderColor: 'divider' }}>
            <Typography variant="overline" color="text.secondary" fontWeight={700}>
                {new Intl.DateTimeFormat('ru-RU', { weekday: 'long', day: 'numeric', month: 'long' }).format(new Date())}
            </Typography>
            {userFio && (
                <Typography variant="h4" sx={{ mt: 0.5, mb: 1 }}>
                    Добрый день, {userFio}
                </Typography>
            )}

            <Chip label={roleName} size="small" sx={{ bgcolor: 'primary.light', color: 'primary.dark', fontWeight: 700 }} />
        </Box>
    );
};
